import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinpune() {



const cardData =
  {
    keyword: 'Bus Hire in Pune',
    heading: 'Sanavi Travels: Bus Hire in Pune',
    headingDescription: 'Sanavi Travels offers reliable, comfortable, and professional Bus Hire in Pune for all types of group transportation needs. Pune is a major metropolitan city, educational hub, IT center, industrial zone, and cultural capital of Maharashtra, generating constant demand for organized group travel. From corporate offices, IT parks, colleges, schools, factories, and event venues to tourist attractions and outstation routes, Pune requires dependable bus rental services every day. Sanavi Travels fulfills this demand with a diverse fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses suitable for city travel, highways, and long-distance journeys. Each bus is well-maintained with clean interiors, comfortable seating, smooth suspension, and ample luggage space, ensuring a relaxed travel experience even in busy city traffic.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is one of Pune’s most iconic historical landmarks and a symbol of Maratha heritage. The fort attracts tourists, students, history enthusiasts, and cultural groups throughout the year. Bus hire services are commonly used for school excursions, heritage walks, corporate outings, and guided city tours, allowing large groups to explore Pune’s history comfortably and efficiently."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular trekking and picnic destination near Pune, offering scenic views and historical significance. Schools, colleges, offices, and tourist groups frequently hire buses for safe and organized travel to the fort, especially during weekends and monsoon seasons."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an important historical and architectural landmark associated with Mahatma Gandhi. Educational institutions and tourists often use bus rental services to visit the palace as part of heritage and educational tours."
  },
  {
    "title": "Pune IT Parks and Corporate Hubs",
    "description": "Pune is home to major IT parks and corporate zones like Hinjewadi, Magarpatta, Kharadi, and Baner. Bus hire services play a vital role in employee transportation, corporate events, training programs, and team outings."
  },
  {
    "title": "Educational Institutions",
    "description": "Pune hosts numerous schools, colleges, and universities. Bus rentals are widely used for daily student transport, educational tours, competitions, industrial visits, and cultural programs."
  },
  {
    "title": "Religious and Spiritual Places",
    "description": "Pune and nearby regions have many temples and spiritual centers that attract devotees year-round. Group pilgrimages and religious tours are conveniently managed through bus hire services."
  },
  {
    "title": "Picnic and Recreation Spots",
    "description": "Pune is surrounded by picnic spots, dams, hills, and nature trails. Families, schools, and offices frequently hire buses for leisure trips, outings, and wellness retreats."
  },
  {
    "title": "Event and Wedding Venues",
    "description": "Pune has numerous banquet halls, wedding lawns, and convention centers. Bus rentals help manage guest transportation efficiently for weddings and large social events."
  },
  {
    "title": "Industrial Areas",
    "description": "Industrial zones such as Pimpri-Chinchwad, Ranjangaon, Chakan, and Talegaon generate daily demand for workforce and logistics-related transportation, making bus hire essential."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Pune is well connected to destinations like Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, and Goa. Bus rentals provide a comfortable and economical solution for group outstation travel."
  }
]
,



"services": [
{
"name": "Bus Hire in Pune",
"description": "Bus Hire in Pune provides comprehensive group transportation solutions for corporate travel, educational institutions, weddings, picnics, religious tours, industrial staff transport, and long-distance journeys. With Pune’s heavy traffic and diverse travel requirements, hiring a professionally managed bus ensures punctuality, safety, and convenience. Sanavi Travels offers clean, well-maintained buses with comfortable seating, smooth suspension, and ample luggage space, making city travel and highway journeys equally comfortable. Experienced drivers familiar with Pune’s roads, traffic patterns, and highways ensure disciplined driving and smooth coordination, reducing travel stress for groups of all sizes."
},
{
"name": "Bus on Rent Pune",
"description": "Bus on Rent Pune offers flexible rental options including hourly, full-day, event-based, and outstation packages. Ideal for families, schools, offices, and tour groups, this service ensures reliable transportation without the hassles of managing multiple vehicles or drivers."
},
{
"name": "AC Bus Rental Pune",
"description": "AC Bus Rental Pune ensures a cool, comfortable, and fatigue-free journey, especially during summer and long-distance travel. Air-conditioned buses are preferred for corporate travel, weddings, and premium group transportation."
},
{
"name": "Non AC Bus Hire Pune",
"description": "Non AC Bus Hire Pune provides a cost-effective solution for short-distance travel, school trips, local events, and budget-conscious group transportation while maintaining safety and reliability."
},
{
"name": "Luxury Bus Hire Pune",
"description": "Luxury Bus Hire Pune offers premium interiors, superior seating comfort, and an enhanced travel experience, making it ideal for VIP guests, corporate executives, and high-profile events."
},
{
"name": "Mini Bus Hire Pune",
"description": "Mini Bus Hire Pune is suitable for small to medium-sized groups, offering flexibility, easy maneuverability in city traffic, and economical pricing."
},
{
"name": "32 Seater Bus on Rent Pune",
"description": "32 Seater Bus on Rent Pune is perfect for schools, offices, and medium-sized tour groups, balancing capacity and comfort for city and outstation travel."
},
{
"name": "35 Seater Bus Hire Pune",
"description": "35 Seater Bus Hire Pune supports larger group requirements such as weddings, conferences, and long-distance tours with reliable performance."
},
{
"name": "Bus Hire Pune for Wedding",
"description": "Bus Hire Pune for Wedding ensures organized and timely guest transportation between venues, hotels, and homes, reducing logistical challenges during celebrations."
},
{
"name": "Bus Hire Pune for Corporate Travel",
"description": "Bus Hire Pune for Corporate Travel provides professional transport solutions for employee commutes, meetings, training programs, and corporate outings."
},
{
"name": "Bus Hire Pune for Picnic",
"description": "Bus Hire Pune for Picnic offers safe and enjoyable group travel for schools, offices, and families planning leisure and recreational trips."
},
{
"name": "Bus Rental Pune Outstation",
"description": "Bus Rental Pune Outstation provides dependable long-distance transportation to major tourist and religious destinations with comfort and safety."
},
{
"name": "Bus Hire Pune with Driver",
"description": "Bus Hire Pune with Driver ensures hassle-free travel with experienced chauffeurs managing routes, traffic, and schedules professionally."
},
{
"name": "Affordable Bus Rental Pune",
"description": "Affordable Bus Rental Pune offers budget-friendly options without compromising on vehicle quality, cleanliness, or service reliability."
},
{
"name": "Best Bus Service Pune",
"description": "Best Bus Service Pune is trusted for punctual service, transparent pricing, professional drivers, and high customer satisfaction delivered by Sanavi Travels."
}
],
"tableData": [
["Bus Hire in Pune", "Bus on Rent Pune"],
["AC Bus Rental Pune", "Non AC Bus Hire Pune"],
["Luxury Bus Pune", "Mini Bus Hire Pune"],
["32 Seater Bus Pune", "35 Seater Bus Pune"],
["Wedding Bus Pune", "Corporate Bus Pune"],
["Picnic Bus Pune", "Outstation Bus Pune"],
["Bus Hire Pune with Driver", "Affordable Bus Rental Pune"],
["Best Bus Service Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels delivers reliable and professional bus rental services across Pune."
  },
  {
    "WhyChooseheading": "Experienced City and Highway Drivers",
    "WhyChoosedescription": "Drivers are well-trained and familiar with Pune city routes and highways."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet",
    "WhyChoosedescription": "Buses are regularly serviced and cleaned for maximum comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "No hidden charges with clear cost breakdown."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Round-the-clock assistance for bookings and coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Hourly, daily, event-based, and outstation packages available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Buses",
    "WhyChoosedescription": "All buses are sanitized before each trip."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "On-time pickups and smooth journey management."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services in Pune?',
    answer: 'Yes, Sanavi Travels offers complete bus hire services across Pune.'
  },
  {
    question: 'What types of buses are available in Pune?',
    answer: 'AC buses, Non AC buses, mini buses, luxury buses, and 32/35-seater buses are available.'
  },
  {
    question: 'Is bus hire available for corporate and wedding events?',
    answer: 'Yes, dedicated buses are available for corporate events and weddings.'
  },
  {
    question: 'Can I book a bus for outstation travel from Pune?',
    answer: 'Yes, outstation bus rental services are available from Pune.'
  },
  {
    question: 'Are buses cleaned and sanitized?',
    answer: 'Yes, all buses are cleaned and sanitized before every journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Deshmukh',
    feedback: 'We hired a bus in Pune for a corporate event. Excellent service and very professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Sanavi Travels provided comfortable buses for our school picnic. Highly recommended.',
    rating: 5
  }
];






















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Pune - Sanavi Travels",
  "description": "Sanavi Travels offers bus hire in Pune for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus hire in Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/241.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinpune;